import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { 
  setNestedPage,
  setNestedPageSize,
  setNestedParams,
  getActivityLog
} from "redux/crm/contactSlice";
import ActivityHistory from "components/common/ActivityHistory";
import React from 'react';

const ContactActivity = () => {
  const {activityLogData} = useSelector(state => state.crm_contact);
  const params = useParams();

  return (
    <ActivityHistory
      activityLogData={activityLogData}
      setNestedPage={setNestedPage}
      setNestedPageSize={setNestedPageSize}
      setNestedParams={setNestedParams}
      getActivityLog={getActivityLog}
      contactId={params.id} //dynamic params to activity
    />
  )
}

export default ContactActivity;